import { render, staticRenderFns } from "./ChangeExerciseCard.vue?vue&type=template&id=53b0f1c0&scoped=true"
import script from "./ChangeExerciseCard.vue?vue&type=script&lang=js"
export * from "./ChangeExerciseCard.vue?vue&type=script&lang=js"
import style0 from "./ChangeExerciseCard.vue?vue&type=style&index=0&id=53b0f1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b0f1c0",
  null
  
)

export default component.exports